import type { ReactNode } from 'react'

/**
 * hr2-v2 (E9): Standard-Seitenkopf der HR-Arbeitsseiten — weisser Sticky-
 * Balken mit Icon-Badge, Titel, Kurzbeschreibung und Aktions-Slot, im Stil
 * des ConfigPage-Kopfs. Ersetzt die freischwebenden h1-Zeilen.
 */
export function HrPageHeader({ title, description, actions }: {
  title: string
  description?: string
  actions?: ReactNode
}) {
  return (
    <div className="sticky top-0 z-10 px-4 lg:px-6 py-3 border-b bg-white flex items-center justify-between gap-4 flex-shrink-0">
      <div className="flex items-center gap-3 min-w-0">
        <div className="w-9 h-9 rounded-lg bg-indigo-50 flex items-center justify-center flex-shrink-0">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-5 h-5 text-indigo-600">
            <circle cx="12" cy="12" r="10" />
            <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <div className="min-w-0">
          <h1 className="text-lg font-bold truncate">{title}</h1>
          {description && <p className="text-xs text-gray-500 max-w-2xl line-clamp-2 sm:line-clamp-none">{description}</p>}
        </div>
      </div>
      {actions && <div className="flex items-center gap-2 flex-shrink-0">{actions}</div>}
    </div>
  )
}
